import {takeEvery, takeLatest, put, call, all, fork} from "redux-saga/effects"

import {
  FILES_FILTER,
  FILES_SEGMENTS,
  FILES_LIST,
  FILES_PROCESS_REFRESH,
  FILES_SLIP_QR_UPDATE,
  FILES_DOWNLOAD,
  FILES_SLIP_MKSOFT_DOWNLOAD,
  FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD,
  FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD,
} from "./actionTypes"

import {
  filesFilterSuccess,
  filesFilterError,
  filesSegmentsSuccess,
  filesSegmentsError,
  filesListSuccess,
  filesListError,
} from "./actions"

import {
  apiGetFilesFilter,
  apiPostFilesSegments,
  apiGetFilesList,
  apiGetFilesProcessRefresh,
  apiPostFilesSlipQRUpdate,
  apiDownloadFilesDownload,
  apiDownloadFilesSlipMKSoftDownload,
  apiDownloadFilesInvoiceIssuedMKSoftDownload,
  apiDownloadFilesDeliveredIssuedMKSoftDownload,
} from "../../api/calls/files"

function* filesFilter({payload: data}) {
  try {
    const response = yield call(apiGetFilesFilter, data)
    yield put(filesFilterSuccess(response))
  } catch (error) {
    yield put(filesFilterError(error))
  }
}

function* filesSegments({payload: data}) {
  try {
    const response = yield call(apiPostFilesSegments, data)
    yield put(filesSegmentsSuccess(response))
  } catch (error) {
    yield put(filesSegmentsError(error))
  }
}

function* filesList({payload: data}) {
  try {
    const response = yield call(apiGetFilesList, data)
    yield put(filesListSuccess(response))
  } catch (error) {
    yield put(filesListError(error))
  }
}

function* filesProcessRefresh({payload: data}) {
  try {
    yield call(apiGetFilesProcessRefresh, data)
    data.refreshFiles()
  } catch (error) {
  }
}

function* filesSlipQRUpdate({payload: data}) {
  try {
    yield call(apiPostFilesSlipQRUpdate, data)
    data.refreshFiles()
  } catch (error) {
  }
}

function* filesDownload({payload: data}) {
  try {
    yield call(apiDownloadFilesDownload, data)
  } catch (error) {
  }
}

function* filesSlipMKSoftDownload({payload: data}) {
  try {
    yield call(apiDownloadFilesSlipMKSoftDownload, data)
  } catch (error) {
  }
}

function* filesInvoiceIssuedMKSoftDownload({payload: data}) {
  try {
    yield call(apiDownloadFilesInvoiceIssuedMKSoftDownload, data)
  } catch (error) {
  }
}

function* filesInvoiceDeliveredMKSoftDownload({payload: data}) {
  try {
    yield call(apiDownloadFilesDeliveredIssuedMKSoftDownload, data)
  } catch (error) {
  }
}

export function* watchFilesFilter() {
  yield takeEvery(FILES_FILTER, filesFilter);
}

export function* watchFilesSegments() {
  yield takeEvery(FILES_SEGMENTS, filesSegments);
}

export function* watchFilesList() {
  yield takeLatest(FILES_LIST, filesList);
}

export function* watchFilesProcessRefresh() {
  yield takeLatest(FILES_PROCESS_REFRESH, filesProcessRefresh);
}

export function* watchFilesSlipQRUpdate() {
  yield takeLatest(FILES_SLIP_QR_UPDATE, filesSlipQRUpdate);
}

export function* watchFilesDownload() {
  yield takeLatest(FILES_DOWNLOAD, filesDownload);
}

export function* watchFilesSlipMKSoftDownload() {
  yield takeLatest(FILES_SLIP_MKSOFT_DOWNLOAD, filesSlipMKSoftDownload);
}

export function* watchFilesInvoiceIssuedMKSoftDownload() {
  yield takeLatest(FILES_INVOICE_ISSUED_MKSOFT_DOWNLOAD, filesInvoiceIssuedMKSoftDownload);
}

export function* watchFilesInvoiceDeliveredMKSoftDownload() {
  yield takeLatest(FILES_INVOICE_DELIVERED_MKSOFT_DOWNLOAD, filesInvoiceDeliveredMKSoftDownload);
}

function* filesSaga() {
  yield all([
    fork(watchFilesFilter),
    fork(watchFilesSegments),
    fork(watchFilesList),
    fork(watchFilesProcessRefresh),
    fork(watchFilesSlipQRUpdate),
    fork(watchFilesDownload),
    fork(watchFilesSlipMKSoftDownload),
    fork(watchFilesInvoiceIssuedMKSoftDownload),
    fork(watchFilesInvoiceDeliveredMKSoftDownload),
  ]);
}

export default filesSaga
